import _ from "lodash";
import axios from "axios";
import config from "../config";

const ax = axios.create({
  baseURL: config,
  timeout: 60000,
});

/** 偏好設定「隱藏示範資料」的 localStorage key（與 pages/Setting/Preferences.js 共用） */
export const HIDE_DEMO_KEY = "HIDE_DEMO";

/**
 * 每一支請求都帶上是否隱藏示範資料。
 * 放在攔截器而不是各個 service，是因為後端用 EF 全域查詢過濾器處理，
 * 只要標頭有帶，所有端點就一致生效——任何一頁漏帶都會造成資料前後不一。
 *
 * 預設隱藏：沒設定過（新瀏覽器、清過 localStorage）就當成要隱藏，
 * 只有明確選「顯示示範資料」才會存成 "0"。預設值只能放在前端——
 * 後端是「有帶標頭才隱藏」，把它改成預設隱藏就沒有辦法表達「我要看示範資料」。
 */
ax.interceptors.request.use((cfg) => {
  if (localStorage.getItem(HIDE_DEMO_KEY) !== "0") {
    cfg.headers = { ...(cfg.headers || {}), "X-Hide-Demo": "1" };
  }
  return cfg;
});

function responseData(res) {
  return res.data;
}

function checkStatus(res) {
  if (res.status >= 200 && res.status < 300) {
    return res;
  }

  const error = new Error(res.statusText);
  error.response = res;
  throw error;
}

async function call(_path, _method, _params = {}, _extendOption = {}) {
  let option = {
    url: _path,
    method: _method,
  };

  switch (_.toUpper(_method)) {
    case "PUT":
    case "POST":
    case "PATCH":
      option.data = _params;
      break;
    case "GET":
    case "DELETE":
      option.params = _params;
      break;
    default:
      break;
  }

  option = {
    ...option,
    ..._extendOption,
  };

  return ax.request(option).then(checkStatus).then(responseData);
}

function generateShortCutMethod(_method) {
  return (_path, _params = {}, _extendOption = {}) => {
    return call(_path, _.toUpper(_method), _params, _extendOption);
  };
}

const func = {
  call,
  get: generateShortCutMethod("GET"),
  post: generateShortCutMethod("POST"),
  put: generateShortCutMethod("PUT"),
  patch: generateShortCutMethod("PATCH"),
  delete: generateShortCutMethod("DELETE"),
};

export default func;
